
import Popup from '@/views/popup/Popup'
export default [
    {
        path: '/popup/:id',
        name: 'popup',
        component: Popup,
        meta: { 
            auth: true,
            logging: true,
            path: '/popup',
            pageName: '팝업',
        }
    },
]